module.exports = __webpack_public_path__ + "media/images/icons/flags/TD-b177acb328101858982292726eb93765.svg";